
import { mapGetters, mapState } from 'vuex';
import TransitionExpand from '@/transitions/TransitionExpand';
import ProductSortType from '@/enums/ProductSortType';
import ProductListDisplayField from '@/enums/ProductListDisplayField';
import PriceRange from '@/enums/PriceRange';
import ProductDisplayFilter from '@/enums/ProductDisplayFilter';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
export default {
  name: 'AppProductSearchBar',
  components: { TransitionExpand },
  props: {
    defaultSortType: {
      type: Number,
      default: ProductSortType.RECENTLY_REVIEWED
    },
    initialQuery: { type: String, default: '' },
    initialCategoryId: { type: Number, default: null },
    initialPriceRange: { type: Number, default: null }
  },
  data() {
    return {
      selectedSortType: ProductSortType.RECENTLY_REVIEWED,
      enableSearchButton: false,
      isSubmitStatus: false,
      query: '',
      selectedCategoryId: null,
      selectedPriceRange: null
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapGetters('productCategories', ['filterableProductCategories']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    showSort() {
      return (
        (this.widget.list_display_fields & ProductListDisplayField.SORT) !== 0
      );
    },
    showAdvancedSearch() {
      return (
        (this.widget.list_display_fields &
          ProductListDisplayField.ADVANCED_SEARCH) !==
        0
      );
    },
    showCategory() {
      return (
        (this.widget.list_display_fields & ProductListDisplayField.CATEGORY) !==
          0 && this.categoryOptions.length > 0
      );
    },
    showPriceRange() {
      return (
        (this.widget.list_display_fields &
          ProductListDisplayField.PRICE_RANGE) !==
        0
      );
    },
    showFilterResetButton() {
      return !!(this.selectedCategoryId || this.selectedPriceRange);
    },
    categoryOptions() {
      return this.filterableProductCategories.map(({ id, name }) => ({
        name,
        value: id
      }));
    },
    priceRangeOptions() {
      return PriceRange.options().map(o => ({ value: o.value, name: o.label }));
    },
    displayableSortOptions() {
      return ProductSortType.values
        .filter(sortType => (this.widget.sort_types & sortType) !== 0)
        .map(sortType => ({
          value: sortType,
          name: ProductSortType.t(sortType)
        }));
    }
  },
  created() {
    this.selectedSortType =
      this.defaultSortType || this.widget.default_sort_type;
    if (this.initialQuery) {
      this.enableSearchButton = true;
      this.isSubmitStatus = true;
      this.query = this.initialQuery;
    }
    if (
      this.widget.product_display_filter ===
      ProductDisplayFilter.SELECTED_CATEGORY
    ) {
      this.selectedCategoryId = this.widget.category_id;
    } else if (this.initialCategoryId) {
      this.selectedCategoryId = this.initialCategoryId;
    }
    if (this.initialPriceRange)
      this.selectedPriceRange = this.initialPriceRange;
  },
  methods: {
    submit(params) {
      this.$emit('submit', { ...params, page: '1' });
    },
    enableSearch(enable) {
      this.enableSearchButton = enable;
      if (this.enableSearchButton) {
        this.$nextTick(() => this.$refs.search_input.focus());
      }
    },
    submitSearchInput() {
      this.isSubmitStatus = this.query?.length > 0;
      this.submit({ query: this.query });
    },
    enterSearchInput() {
      if (this.enableSearchButton) {
        this.submitSearchInput();
        this.$nextTick(() => this.$refs.search_input.focus());
      }
    },
    resetFilters() {
      this.selectedCategoryId = null;
      this.selectedPriceRange = null;
      this.submit({ category_id: null, price_range: null });
    }
  }
};
